import { ControllersDataItem } from '@/logic/main/types';

export const checkIfFetchStrikeGold = (
  controllersData?: Pick<ControllersDataItem, 'components'>
) => {
  if (!controllersData) {
    return false;
  }
  const { components = [] } = controllersData;
  return (
    components &&
    components.some(component => {
      return (
        component[1].properties.custom_widget_tile &&
        component[1].properties.custom_widget_tile.type === 'strike-gold'
      );
    })
  );
};
